import { TemplateField, TemplatePage } from "../../../../api/applicationService";
import { Dependent } from "../../../../contexts";
import { getDialCode, getStates } from "../../utils/utils";

const hiddenFieldIdsAlways_OnLoad = new Set([
    '43fcb9f7-fa03-4452-a6a4-591aa1fff9c7',
    'a34fea12-f31b-44c2-b640-7c1c884e9a11',
    'cfaa212e-ffdd-4f7e-8494-ba7a3397dc8f',
    '9e8e4349-5f9a-43e7-a048-856955040966',
    '7a8197fb-6644-4271-8e56-1bf07b45f3f6',
    'e6750fb6-039b-46a2-8a3a-05f4814edbd3',
    'b8c7b34b-35ae-4536-9f69-04c3cc19a082',
    '4c24549c-6916-48c6-9b5a-a2cb7c7cbfca',
    '238f0c3b-a5b9-461c-a617-a6e67597a90a',
    '980fd863-39a6-4854-a45f-adc7cf71dab9',
    '78c27639-1b6a-4d68-bb7c-6aef3fd2e715',
    '858365c8-0816-4c48-aac3-afc8d68d026f',
    '2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf',
    'b8dfb250-3165-4dd3-a9ee-d6d8ea88539a',
    'f71537b2-4802-4999-bb68-ad1265658576',
    '55e1c5d7-81c7-4ab9-911f-700977a230c8',
    '5e7529d9-2a72-46e6-92c2-405c6ab02c1c',
    'a93ece21-1eb4-4120-b5fc-615ea6e5852b',
    '1b3b2040-c6eb-4b3a-8e06-0f1cc35720f4',
    '7d9a3e29-6d19-4cdd-b0c2-914d04b46aa3',
    '677b4d85-149b-45ac-97b9-7cc80ee69407',
    'c013f7ab-325b-47d7-bfdf-887019f17cbf',

]);

export const applyFieldLogic_OnLoad = async (
    field: TemplateField,
    quote: any,
    dependents: Dependent[],
    pageId: string,
    countryOptions: any[],
    isAlreadyAnswered: boolean
) => {
    const { question_id } = field;
    // Reglas para maxFiles
    if (question_id === '8bbf91bf-bca9-456f-9d6a-26850ce9d6c0') {
        field.maxFiles = 5;
        field.hidden = false;
    }

    // Reglas para multipleChoiceColumns
    if ([
        'ad1e32bd-6976-4068-80c1-6ccbd441e1ed',
        'ee28511c-8c76-4fb1-a208-5674b04353d0',
        'd97c485f-51db-40fe-8304-6cc457a095a4',
        '266cb0ed-4d3c-4b0e-b75f-098d9f00ce8c',
        '4ea018bf-7570-4e4c-adc5-617077134715',
        'b733d73a-68bd-4cbe-87c7-c792c01664fe',
    ].includes(question_id || '')) {
        field.multipleChoiceColumns = 1;
    }

    // Reglas para maxDate
    const setMaxDateToday = [
        '7ad84f6e-be8f-4e13-a489-ba71e558b6eb',
        '0d55c92f-3e86-4ae3-a9b8-86c3014ecc16',
        'c1e0db0d-4d06-4638-bdde-79a9703842d1',
        '8743861d-d059-457f-a8d1-59e69ab1507d',
        'e671dc70-ddd5-4396-bd6a-853d3a186335',
        'b0e3d871-18f6-4d7b-85d7-fd34b6c65b13',
        '6f35e3e8-e182-4ce0-9290-8d57600c9eb7',
        '493d650f-7d8a-4748-add7-627d0a69b1fa',
        '08904b10-33c8-44a3-81ee-7ea2ad02da7d',
        '68c29157-e96d-48fc-88ea-33fb1afe0ddf',
        '99a4cc3c-f1e9-40be-b290-37e45b576c4f',
        '90806065-0d4c-4818-a31e-05d691195368',
        'f76f697f-80e4-4c0c-8f80-1289683898ae',
        '09f12c9b-580a-44f3-81dd-74c6c6e40eec'
    ];

    if (setMaxDateToday.includes(question_id || '')) {
        field.maxDate = 'today';
    }

    // Caso especial para maxDate = today-1
    if (question_id === 'cb4d9886-2b40-4f27-8d90-f01d759bd510') {
        field.maxDate = 'today-1';
    }

    // Reglas para minUnitValue y maxUnitValue
    if (question_id === '1b3b2040-c6eb-4b3a-8e06-0f1cc35720f4') {
        field.minUnitValue = 1;
        field.maxUnitValue = 300;
    }

    if (question_id === 'b644fa04-e96f-4761-8553-1c00c7d115c6') {
        field.minNumber = 0;
        field.maxNumber = 64;
    }


    if (!isAlreadyAnswered) {
        if (pageId === '0d7e941e-7c31-41ee-95f4-622c54525a72') {
            console.log('is not answered');
            const fillLeadData: any = {
                '773e8c82-3c69-4745-8520-43ac32b1b030': quote?.lead?.first_name,
                '84f4b5e2-a240-4405-839b-a35924df2fa8': quote?.lead?.last_name,
                'a1c1f62e-326b-46f0-bb7d-33d436ca267d': quote?.lead?.email,
                '103a15f4-0d02-496a-bf0f-994ee9e4b945': quote?.lead?.phone || getDialCode(quote?.country_origin),
            };
            if (fillLeadData[question_id] !== undefined) {
                field.value = fillLeadData[question_id];
            }
        }
    }
    if (pageId === 'd487348e-4062-4daa-92fc-854869a2fc81') {
        if (question_id === '103a15f4-0d02-496a-bf0f-994ee9e4b945') {
            field.value = getDialCode(quote?.country_origin);
        }
    }

    if (hiddenFieldIdsAlways_OnLoad.has(question_id)) {
        if (
            [
                '6d533b7f-5698-4eaa-a9ce-a7c47f320a89',
                '35a04d2e-a8c0-4313-be5b-e531c219f9b1',
                'c3ba699c-f173-4f13-84b7-59cdd9d2e579',
                '99fc15df-21a9-454b-8c98-a1de719c4362',
                '133b3a35-1c82-4b66-aa24-956f01062da4',
                '0bb664c3-720a-49ea-aa07-3d307357a930',
                'ce92985c-c827-4437-b4c6-8fbb130ddbcd',
                'f75336d7-cd43-4a1c-95d3-136adb13f2c8',
                '2258d150-3cd5-4300-858e-decc15f48e1b',
                '33a0e6e5-c529-4cc7-ac12-20e3b480b93a',
                'ce92985c-c827-4437-b4c6-8fbb130ddbcd',
                '6105330c-5aae-4a7b-b597-aa84f7e573b5',
                'c117f0fe-c687-4cf1-9428-8a672d36b434',
                '449763f5-7a20-4eed-a9c0-1679d19f1005',
                '2e9ec1a1-054e-4a2f-9f43-cd23f9fb272a',
                'f0b7cc30-6245-4293-96f0-2fe0bff87440',
                '6640e390-398c-4cf5-8da9-e0b7182f0149'
            ].includes(pageId)
            &&
            (
                [
                    'f71537b2-4802-4999-bb68-ad1265658576',
                    'e6750fb6-039b-46a2-8a3a-05f4814edbd3',
                    '858365c8-0816-4c48-aac3-afc8d68d026f',
                    '2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf',
                    '78c27639-1b6a-4d68-bb7c-6aef3fd2e715',
                    'b8c7b34b-35ae-4536-9f69-04c3cc19a082',
                    '4c24549c-6916-48c6-9b5a-a2cb7c7cbfca',
                    '980fd863-39a6-4854-a45f-adc7cf71dab9',
                ].includes(question_id)
            )
        ) {
            field.hidden = false;
        } else {
            field.hidden = true;
        }

        // Caso especial: ocultar campos específicos en la página 2e9ec1a1
        const isPageHeartDiseases = pageId === '2e9ec1a1-054e-4a2f-9f43-cd23f9fb272a';
        const SurgeryQuestions = [
            '858365c8-0816-4c48-aac3-afc8d68d026f',
            '2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf'
        ].includes(question_id);

        if (isPageHeartDiseases && SurgeryQuestions) {
            field.hidden = true;
        }

        // Caso especial: ocultar campo específico en la página f4f489ee
        const isPAgeBeneficiaries = pageId === 'f4f489ee-3e2a-4eb2-9542-0f1da59a2d20';
        const isMoreDetailsQuestion = question_id === 'cfaa212e-ffdd-4f7e-8494-ba7a3397dc8f';

        if (isPAgeBeneficiaries && isMoreDetailsQuestion) {
            field.hidden = true;
        }
    }
    if (question_id === 'ce33e4e7-1939-4a45-84b4-a5788c0c6aff') {
        field.options = countryOptions;
        field.value = quote?.country_origin || '';
    }

    if (question_id === '7c4e50cc-4488-4bf6-9388-1f1485fb473e') {
        field.options = getStates(quote?.country_origin);
    }
};

export const replaceTitle = (field: TemplateField, text: string) => {
    const year1 = new Date().getFullYear() - 1;
    const year2 = new Date().getFullYear() - 2;
    if (field.question_id === 'ff1d86d7-e5b0-4e40-ac24-7327d6c1404f') {
        return text.replace('$1', year1.toString());
    }
    if (field.question_id === '556bfe93-17ee-453b-bb3f-fcb706251fec') {
        return text.replace('$2', year2.toString());
    }
    return text;
}

const getValue = (field: TemplateField) => {
    if (field.value) {
        return field.value;
    }
    if (field.value_default) {
        return field.value_default;
    }
    return '';
}

export const extractValue = (page: TemplatePage, sectionId: string, groupId: string, fieldId: string) => {
    const section = page?.sections?.find(section => section.section_id === sectionId);
    const group = section?.groups?.find(group => group.group_id === groupId);
    const field = group?.fields?.find(field => field.question_id === fieldId);
    if (field) {
        return getValue(field);
    }
    return '';
}